import React, { useContext, useEffect, useState } from 'react';
import STAR_ICON from '../assets/icons/ComniqaiIcon-V3.0/star-icon.svg';
import MESSAGE_ICON from '../assets/icons/ComniqaiIcon-V3.0/message-icon.svg';
import LEAD_ICON from '../assets/icons/ComniqaiIcon-V3.0/lead-qualification-icon.svg';
import LEAP_ICON from '../assets/icons/ComniqaiIcon-V3.0/leap-whiteicon.svg';
import KNOWLEDGEHUB_ICON from '../assets/icons/ComniqaiIcon-V3.0/knowledgehub-activeicon.svg';
import ANALYTICS_ICON from '../assets/icons/ComniqaiIcon-V3.0/analytics-icon.svg';
import SCANURL_ICON from '../assets/icons/ComniqaiIcon-V3.0/scan-url-deactiveicon.svg';
import MULTISTAR_ICON from '../assets/icons/ComniqaiIcon-V3.0/multistar-icon.svg';
import UPLOAD_BLUE_ICON from '../assets/icons/ComniqaiIcon-V3.0/upload-blue-icon.svg';
import TEXT_PURPLE_ICON from '../assets/icons/ComniqaiIcon-V3.0/text-purpleicon.svg';
import { MdArrowForward, MdArrowForwardIos, MdOutlineChatBubbleOutline, MdOutlineThumbUpOffAlt } from 'react-icons/md';
import { RxLightningBolt } from 'react-icons/rx';
import { SiGoogleanalytics } from 'react-icons/si';
import { FaCheck, FaCheckCircle, FaRegFilePdf, FaBuilding } from 'react-icons/fa';
import { HiOutlineCheckBadge } from 'react-icons/hi2';
import { FiUpload } from 'react-icons/fi';
import { CgFileDocument } from 'react-icons/cg';
import { toast } from 'react-toastify';
import { deleteWithToken, getLocalStorage, getWithToken, patchAvtarWithToken, patchWithPdf, patchWithToken, postWithToken } from '../API/Api';
import { RiDeleteBin6Line } from 'react-icons/ri';
import ButtonLoader from './ButtonLoader';
import { useNavigate } from 'react-router-dom';
import COUNTRYLIST from '../Country_Nationality_List.json';
import UPLOAD_ICON from '../assets/icons/ComniqaiIcon-V2.0/upload-icon.svg';
import SubContext from '../contexts/SubContext';
import useProgress from '../hooks/useProgress';
import { useMemo } from 'react';
import { getPlanLevel, PLAN_LEVELS } from '../API/Constant';

const onboardingContent = {
  1: {
    title: 'Welcome to ComniqAI',
    subtitle: 'The one AI bot that <strong>TRULY</strong> understands your business in seconds',
  },
  2: {
    title: 'Set Up Your Company Profile',
    subtitle: 'Help your AI understand your business by setting up your company profile.',
  },
  3: {
    title: 'Complete Your Company Information',
    subtitle: 'Check your company information to help your AI provide better assistance.',
  },
  4: {
    title: 'Train Your AI Agent',
    subtitle: 'Simply push to continue',
  },
  5: {
    title: 'Your Questions, Your Criteria, Your Leads',
    subtitle: 'Leap is our all new lead generation powerhouse',
  },
  6: {
    title: 'Publish Chatbot',
    subtitle: 'Your changes are ready to go live. <br/> Click Publish to make these updates available for testing and for all public users.',
  },
  7: {
    title: 'You’re All Set!',
    subtitle: 'Start growing your business with ComniqAI’s AI-powered tools',
  },
};

const FileItem = ({ file, isUploaded, progress, onDelete }) => (
  <div className='file-upload-item d-flex align-items-center justify-content-between mb-3 w-100'>
    <div className='file-name d-flex align-items-center'>
      <FaRegFilePdf className='me-2' />
      {file.name}
    </div>
    <div className='file-actions d-flex align-items-center gap-3'>
      {isUploaded ? (
        <FaCheckCircle className='text-success' />
      ) : (
        <div className='progress' style={{ width: '80px', height: '10px' }}>
          <div className='progress-bar' style={{ width: `${progress}%` }} />
        </div>
      )}
      <div className='cursor-pointer'>
        <RiDeleteBin6Line onClick={onDelete} />
      </div>
    </div>
  </div>
);
const maxLength = 1500;

const ValidationErrors = { empty: { company: 'Company name required' } };

const countCharacters = (text) => {
  if (text) {
    return text.length;
  }
  return 0;
};

const OnboardingPopup = ({ onClose, refreshUserProfile }) => {
  const navigate = useNavigate();
  const { startPolling } = useProgress();
  const subsFlag = useContext(SubContext);
  const subscriptionInfo = subsFlag?.subscriptionFlag?.user?.subscription ?? null;
  const subscriptionName = subscriptionInfo?.name ?? 'Free';
  const planLevel = useMemo(() => getPlanLevel(subscriptionName), [subscriptionName]);
  const [currentStep, setCurrentStep] = useState(1);
  const [apiTokenData, setApiTokenData] = useState('');
  const [activeOption, setActiveOption] = useState(null);
  const [scan_url, setScan_url] = useState('');
  const [scaning, setScaning] = useState(false);
  const [progress, setProgress] = useState(0);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadedPdf, setUploadedPdf] = useState('');
  const [addText, setAddText] = useState('');
  const [scanStatus, setScanStatus] = useState('pending');
  const [isPublishing, setIsPublishing] = useState(false);

  const [companyValues, setCompanyValues] = useState({
    company: '',
    country: '',
    city: '',
    address: '',
    phone_number: '',
    website: '',
    about_company: '',
    booking_link: '',
    chatbot_logo: '',
    chatbot_avtar: '',
  });

  const [loader, setLoader] = useState(false);
  const [botId, setBotId] = useState('');
  const [errors, setErrors] = useState({
    company: '',
  });

  const { company, country, city, phone_number, address, website, booking_link, about_company, chatbot_logo, chatbot_avtar } = companyValues;
  const [logoPreview, setLogoPreview] = useState('');
  const [previewAvtarIcon, setPreviewAvtarIcon] = useState(null);

  useEffect(() => {
    let token = getLocalStorage('apiToken');
    if (token) {
      setApiTokenData(JSON.parse(token));
    }
  }, []);

  const fetchLogoDetails = async (token) => {
    setLoader(true);
    await getWithToken('Webchat_widgetAPI/', token)
      .then((response) => {
        if (response.status === 200) {
          setCompanyValues((prev) => ({
            ...prev,
            chatbot_logo: response?.data?.chatbot_logo,
            chatbot_avtar: response?.data?.chatbot_avtar,
          }));
          setLogoPreview(response?.data?.chatbot_logo);
          setPreviewAvtarIcon(response?.data?.chatbot_avtar);
        }
      })
      .catch((error) => {
        toast.error('Something went wrong');
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const getUploadPdf = (token) => {
    getWithToken('PDF_questionsURLAPI', token)
      .then((response) => {
        if (response.status === 200) {
          setUploadedPdf(response?.data);
        }
      })
      .catch((error) => {
        console.error('error: ', error);
      });
  };

  const handleGetText = (token) => {
    getWithToken('Text_questionsURLAPI', token)
      .then((response) => {
        if (response.status === 200) {
          setAddText(response?.data);
        }
      })
      .catch((error) => {
        console.error('error: ', error);
      });
  };

  const handleClosePopup = async () => {
    if (currentStep === 7 || scanStatus === 'completed') {
      if (refreshUserProfile) {
        await refreshUserProfile();
      }
    }
    onClose();
  };

  const handleNext = () => {
    if (currentStep < 7) {
      setCurrentStep(currentStep + 1);
    } else {
      if (planLevel >= PLAN_LEVELS.Scale) {
        if (scanStatus === 'completed') {
          navigate('/chatbot?tab=testing-area', {
            state: { autostart: true },
          });
        } else {
          navigate('/chatbot?tab=testing-area');
        }
      } else {
        navigate('/chatbot?tab=faqs');
      }
      handleClosePopup();
    }
  };

  const handleBackToOptions = () => {
    setCurrentStep(currentStep);
    setActiveOption(null);
  };

  const getUrlListData = (ScanUrl, token) => {
    if (ScanUrl !== '') {
      setScaning(true);

      postWithToken('generate-faqs-company', token, { url: ScanUrl })
        .then((response) => {
          if (response.status === 200) {
            const taskId = response.task_id;
            localStorage.setItem('activeTaskId', taskId);
            getUploadPdf(apiTokenData);
            handleGetText(apiTokenData);
            setCurrentStep(3);
            getBotDetails(apiTokenData);
            fetchLogoDetails(apiTokenData);
            toast.success(response?.message);
            startPolling(apiTokenData, taskId);
            setScanStatus('completed');
            subsFlag.setUpdateValue('1');
          } else {
            toast.error(response?.message);
          }
        })
        .catch((error) => {
          console.error('error: ', error);
          toast.error('Something went wrong');
        })
        .finally(() => {
          setScaning(false);
        });
    } else {
      toast.error('Enter website URL');
    }
  };

  const companyHandleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'about_company') {
      if (value.length >= maxLength) {
        toast.dismiss();
        toast.info('Character limit exceeded! Please keep it under 1500 characters.');
      }
    }

    setCompanyValues({ ...companyValues, [name]: value });
    setErrors({ ...errors, [name]: '' });
  };

  const getBotDetails = async (token) => {
    try {
      setLoader(true);
      const response = await getWithToken('company/', token);

      if (response.status === 201 || response.status === 200) {
        if (response.status === 201) {
          setBotId(response?.data?.id);
          setCompanyValues((prev) => ({
            ...prev,
            company: response?.data?.company,
            country: response?.data?.country,
            city: response?.data?.city,
            address: response?.data?.address,
            phone_number: response?.data?.phone_number,
            website: response?.data?.website,
            about_company: response?.data?.about_company,
            booking_link: response?.data?.booking_link,
          }));
        }
      }
    } catch (error) {
      console.error('error: ', error);
    } finally {
      setLoader(false);
    }
  };

  const handleLogoUpload = async (e) => {
    if (e.target.files) {
      const file = e.target.files[0];
      setCompanyValues({ ...companyValues, [e.target.name]: file });

      const reader = new FileReader();
      reader.onload = () => {
        setLogoPreview(reader.result);
      };
      reader.readAsDataURL(file);

      let fd = new FormData();
      fd.append('chatbot_logo', file);

      try {
        const response = await patchAvtarWithToken('Logo_Image_WidgetAPI/', apiTokenData, fd);
        if (response.status === 200) {
          toast.success(response.message);
          fetchLogoDetails(apiTokenData);
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleAvatarUpload = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (!file) return;
    setPreviewAvtarIcon(URL.createObjectURL(file));

    let fd = new FormData();
    fd.append('chatbot_avtar', file);

    patchAvtarWithToken('Avtar_Image_WidgetAPI/', apiTokenData, fd)
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.message);
          fetchLogoDetails(apiTokenData);
        } else {
          toast.error(response.message);
        }
      })
      .catch((error) => {
        console.error('error: ', error);
      });
  };

  const companyHandleClick = () => {
    const tempErrors = { ...errors };
    Object.keys(companyValues).forEach((key) => {
      if (!companyValues[key]) {
        tempErrors[key] = ValidationErrors.empty[key];
      }
    });
    setErrors(tempErrors);

    if (Object.values(tempErrors).filter((obj) => !!obj).length > 0) {
      return false;
    }
    setLoader(true);

    if (botId) {
      patchWithToken('company/' + botId + '/', apiTokenData, companyValues)
        .then((response) => {
          if (response.status === 200) {
            setCurrentStep(4);
            getBotDetails(apiTokenData);
            fetchLogoDetails(apiTokenData);
            toast.success(response.message);
            setLoader(false);
            subsFlag.setUpdateValue('1');
          } else {
            setLoader(false);
            toast.error(response.message);
          }
        })
        .catch((error) => {
          console.error('error: ', error);
          toast.error('Something went wrong');
          setLoader(false);
        });
    }
  };

  const handleSelectFile = async (e) => {
    const selectedFiles = Array.from(e.target.files);
    const pdfFiles = selectedFiles.filter((file) => file.type === 'application/pdf');

    if (!pdfFiles.length) {
      toast.error('Please select only PDF files.');
      return;
    }

    setUploadedFiles(pdfFiles);
    await patchUploadPdf(pdfFiles, apiTokenData);
  };

  const patchUploadPdf = async (files, token) => {
    if (files && files.length) {
      let fd = new FormData();
      files.forEach((file) => fd.append('pdf', file));

      setProgress(10);

      let progressValue = 10;
      const progressInterval = setInterval(() => {
        if (progressValue < 90) {
          progressValue += 5;
          setProgress(progressValue);
        }
      }, 300);

      try {
        const response = await patchWithPdf('PDF_questionsURLAPI', token, fd);
        if (response.status === 200) {
          setUploadedFiles([]);
          toast.success(response.message);
          getUploadPdf(apiTokenData);
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        console.error(error);
        toast.error('Something went wrong during upload.');
      } finally {
        clearInterval(progressInterval);
        setTimeout(() => {
          setProgress(100);
          setTimeout(() => {
            setProgress(0);
          }, 800);
        }, 300);
      }
    }
  };

  const handleUploadedDelete = async (id) => {
    try {
      const response = await deleteWithToken(`PDF_questionsURLAPI/${id}`, apiTokenData);
      if (response.status === 200) {
        getUploadPdf(apiTokenData);
        toast.success(response.message);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleAddText = () => {
    const obj = {
      text: addText,
    };
    patchWithToken('Text_questionsURLAPI', apiTokenData, obj)
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.message);
        } else {
          toast.error(response.message);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const publishChatbotData = async (token) => {
    setIsPublishing(true);
    try {
      const response = await getWithToken('publish-data', token);
      if (response.status === 200) {
        toast.success(response?.message);
        setCurrentStep(7);
      } else {
        toast.error(response.message || 'Failed to publish chatbot');
      }
    } catch (error) {
      console.error('Error publishing chatbot:', error);
      toast.error('Something went wrong while publishing');
    } finally {
      setIsPublishing(false);
    }
  };

  const onFormSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <div className='onboarding-overlay'>
      <div className='onboarding-popup-wrapper d-flex align-items-center justify-content-center'>
        <div className='onboarding-popup shadow-lg rounded-4 p-4 bg-white text-center'>
          <div className='onboarding-progress mb-3'>
            <div className='onboarding-steps'>
              {[1, 2, 3, 4, 5, 6, 7].map((dot, i) => (
                <span key={i} className={`step-dot ${currentStep === dot ? 'active' : ''}`}></span>
              ))}
            </div>
            <div className='close-btn'>
              <button className='btn-close' onClick={() => handleClosePopup()}></button>
            </div>
          </div>

          <div className='onboarding-header text-center'>
            <div className='onboarding-icon'>
              <img src={STAR_ICON} alt='star-icon' />
            </div>
            <h4 className='onboarding-title outfit-bold'>{onboardingContent[currentStep]?.title}</h4>
            <p className='onboarding-subtitle outfit-regular' dangerouslySetInnerHTML={{ __html: onboardingContent[currentStep]?.subtitle }} />
          </div>

          {currentStep === 1 && (
            <>
              <div className='feature-section'>
                <div className='feature-section-text'>
                  <h5 className='outfit-bold'>AI-Powered Engagement</h5>
                  <p className=''>Customer intelligence that grows your business</p>
                </div>

                <div className='row gx-3 gy-3'>
                  <div className='col-md-6 col-12 d-flex'>
                    <div className='feature-card rounded-3'>
                      <img src={MESSAGE_ICON} alt='message-icon' />
                      <h6 className='outfit-bold'>Smart Conversations</h6>
                      <p className='small'>AI-driven chats that convert visitors</p>
                    </div>
                  </div>
                  <div className='col-md-6 col-12 d-flex'>
                    <div className='feature-card rounded-3'>
                      <img src={LEAD_ICON} alt='message-icon' />
                      <h6 className='outfit-bold'>Lead Qualification</h6>
                      <p className='outfit-regular'>Focus on high-value prospects</p>
                    </div>
                  </div>
                  <div className='col-md-6 col-12 d-flex'>
                    <div className='feature-card rounded-3'>
                      <img src={KNOWLEDGEHUB_ICON} alt='message-icon' />
                      <h6 className='outfit-bold'>Knowledge Hub</h6>
                      <p className='small'>Centralize your business data</p>
                    </div>
                  </div>
                  <div className='col-md-6 col-12'>
                    <div className='feature-card rounded-3'>
                      <img src={ANALYTICS_ICON} alt='message-icon' />
                      <h6 className='outfit-bold'>Insights</h6>
                      <p className='small'>Analytics that drive decisions</p>
                    </div>
                  </div>
                </div>
              </div>
              <button className='onboarding-btn outfit-medium d-flex align-items-center justify-content-center gap-2' onClick={handleNext}>
                Continue <MdArrowForwardIos />
              </button>
            </>
          )}

          {currentStep === 2 && (
            <div className='autofill-card p-2 p-md-4'>
              <div className='d-flex align-items-start gap-3 mb-2'>
                <div className='autofill-card-icon'>
                  <img src={SCANURL_ICON} alt='scan-icon' />
                </div>
                <div className='autofill-card-body text-start'>
                  <h6 className='outfit-semibold'>Auto-fill from Website</h6>
                  <p className='outfit-regular'>Watch how ComniqAI seamlessly trains itself specifically on your company just with a simple website URL.</p>
                  <div className='d-flex flex-column flex-md-row align-items-stretch gap-2 mt-3'>
                    <input
                      type='text'
                      className='flex-fill knowledge-hub__input'
                      placeholder='e.g., www.yourcompany.com'
                      value={scan_url}
                      onChange={(e) => setScan_url(e.target.value)}
                    />
                    <button
                      className={`autofill-card-body-button d-flex align-items-center gap-2`}
                      disabled={scaning}
                      style={{ opacity: scaning ? '0.7' : '1' }}
                      onClick={() => getUrlListData(scan_url, apiTokenData)}
                    >
                      {scaning && <ButtonLoader />} <img src={MULTISTAR_ICON} alt='star-icon' />
                      Auto Generate
                    </button>
                  </div>
                </div>
              </div>
              <button
                className='autofill-card-btn outfit-medium d-flex align-items-center justify-content-center gap-2'
                style={{ opacity: scaning ? '0.7' : '1' }}
                onClick={() => setCurrentStep(4)}
                disabled={scaning}
              >
                Skip - I don't have a website <MdArrowForward />
              </button>
            </div>
          )}

          {currentStep === 3 && (
            <div className='company-profile-form text-start'>
              {/* <div className='company-profile-header text-center mb-4'>
                <FaBuilding className='company-profile-icon mb-2' style={{ fontSize: '2rem', color: '#6366f1' }} />
                <p className='outfit-regular text-muted'>Check your company information to help your AI provide better assistance.</p>
              </div> */}

              <form onSubmit={onFormSubmit} className='chatbox-field'>
                <div className='row g-3'>
                  {/* Logo Upload */}
                  <div className='col-12'>
                    <div className='comniq-box-shadow mb-4'>
                      <label className='outfit-semibold mb-2'>Logo</label>
                      <div className='d-flex flex-column flex-md-row align-items-center gap-3'>
                        <div className='logo-upload' onClick={() => document.getElementById('logoInput').click()}>
                          {logoPreview || chatbot_logo ? <img src={logoPreview || chatbot_logo} alt='preview' /> : <img src={UPLOAD_ICON} alt='upload-icon' />}
                        </div>
                        <input type='file' accept='image/*' id='logoInput' style={{ display: 'none' }} onChange={(e) => handleLogoUpload(e)} />

                        <div className='flex-grow-1'>
                          <button className='widget-upload-button outfit-regular' onClick={() => document.getElementById('logoInput').click()}>
                            Upload Logo
                          </button>
                          <div className='outfit-regular bubbles-text m-0'>
                            JPG, PNG, GIF, SVG, WEBP
                            <br />
                            Max: 5mb
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Icon Upload */}
                  <div className='col-12'>
                    <div className='comniq-box-shadow mb-4'>
                      <label className='outfit-semibold mb-2'>Agent Avatar</label>
                      <div className='d-flex align-items-center gap-3 mb-3'>
                        <div className='avatar-upload' id='profilePicPreview'>
                          <div className='upload-icon-wrapper' onClick={() => document.getElementById('newProfilePhoto').click()}>
                            {previewAvtarIcon || chatbot_avtar ? (
                              <img src={previewAvtarIcon || chatbot_avtar} alt='Preview' style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '50%' }} />
                            ) : (
                              <FiUpload size={30} style={{ color: '#d1d5db' }} />
                            )}
                          </div>
                        </div>
                        <div>
                          <input type='file' name='chatbot_avtar' id='newProfilePhoto' accept='image/*' className='d-none' onChange={(e) => handleAvatarUpload(e)} />
                          <div className='flex-grow-1'>
                            <button className='widget-upload-button outfit-regular' onClick={() => document.getElementById('newProfilePhoto').click()}>
                              Upload Avatar
                            </button>
                            <div className='outfit-regular bubbles-text m-0'>
                              JPG, PNG, GIF, SVG, WEBP <br /> Max: 5mb
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className='col-md-6'>
                    <div className='chatbox-input-text input-GPT new'>
                      <label className='outfit-medium'>Company Name*</label>
                      <div className='chatbox-input-field'>
                        <input
                          type='text'
                          placeholder='Luna Compnay Ltd'
                          className='form-control chatbox-input box-shadow-hover'
                          id='company'
                          name='company'
                          value={company}
                          autoComplete='off'
                          onChange={companyHandleChange}
                        />
                        <div className='chat-error'>{errors.company && <p className='text-danger insta-smart-error'>{errors.company}</p>}</div>
                      </div>
                    </div>
                  </div>

                  <div className='col-md-6'>
                    <div className='chatbox-input-text input-GPT new'>
                      <label className='outfit-medium'>Address*</label>
                      <div className='chatbox-input-field'>
                        <input
                          type='text'
                          placeholder='13th Street. 47 W 13th St'
                          id='address'
                          name='address'
                          className='form-control chatbox-input box-shadow-hover'
                          value={address}
                          autoComplete='off'
                          onChange={companyHandleChange}
                        />
                      </div>
                    </div>
                  </div>

                  <div className='col-md-6'>
                    <div className='chatbox-input-text input-GPT new'>
                      <label className='outfit-medium'>City</label>
                      <div className='chatbox-input-field'>
                        <input
                          type='text'
                          placeholder='New York'
                          className='form-control chatbox-input box-shadow-hover'
                          id='city'
                          name='city'
                          value={city}
                          autoComplete='off'
                          onChange={companyHandleChange}
                        />
                      </div>
                    </div>
                  </div>

                  <div className='col-md-6'>
                    <div className='chatbox-input-text input-GPT new'>
                      <label className='outfit-medium'>Country</label>
                      <div className='chatbox-input-field'>
                        <select className='form-control box-shadow-hover' name='country' value={country} onChange={companyHandleChange}>
                          <option selected hidden>
                            Choose the country
                          </option>
                          {COUNTRYLIST.map((row, i) => (
                            <option key={i}>{row?.en_short_name}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className='col-6'>
                    <div className='chatbox-input-text input-GPT new'>
                      <label className='outfit-medium'>Phone Number</label>
                      <div className='chatbox-input-field'>
                        <input
                          type='tel'
                          placeholder='xxxxxxxxxxx'
                          className='form-control chatbox-input box-shadow-hover'
                          id='phone_number'
                          name='phone_number'
                          value={phone_number}
                          autoComplete='off'
                          maxLength={12}
                          onChange={(e) => {
                            if (isNaN(e.target.value)) {
                              return false;
                            } else {
                              companyHandleChange(e);
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className='col-6'>
                    <div className='chatbox-input-text input-GPT new'>
                      <label className='outfit-medium'>Website</label>
                      <div className='chatbox-input-field'>
                        <input
                          type='text'
                          placeholder='https://comniqai.com/'
                          className='form-control chatbox-input box-shadow-hover'
                          id='website'
                          name='website'
                          value={website}
                          autoComplete='off'
                          onChange={companyHandleChange}
                        />
                      </div>
                    </div>
                  </div>

                  <div className='col-12'>
                    <div className='chatbox-input-text input-GPT new'>
                      <label className='outfit-medium'>Booking Link</label>
                      <div className='chatbox-input-field'>
                        <input
                          type='text'
                          placeholder='https://comniqai.com/'
                          className='form-control chatbox-input box-shadow-hover'
                          id='booking_link'
                          name='booking_link'
                          value={booking_link}
                          autoComplete='off'
                          onChange={companyHandleChange}
                        />
                      </div>
                    </div>
                    <small className='text-muted'>Add a link to your booking or scheduling system (e.g. Calendly, Booking.com, etc.)</small>
                  </div>
                  <div className='col-12'>
                    <div className='chatbox-input-text input-GPT new'>
                      <div className='d-flex justify-content-between align-items-center'>
                        <label className='mb-1 outfit-medium'>About Company</label>
                        <p className='mb-0 outfit-regular font14 text-end'>({countCharacters(about_company) || 0} / 1500)</p>
                      </div>
                      <div className='chatbox-input-field'>
                        <textarea
                          rows='10'
                          className='form-control chatbox-input textarea-height box-shadow-hover'
                          placeholder='Describe about your company '
                          id='about_company'
                          name='about_company'
                          value={about_company}
                          autoComplete='off'
                          onChange={companyHandleChange}
                          maxLength={1500}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='d-flex gap-2 mt-4'>
                  <button className='onboarding-btn flex-fill outfit-medium d-flex align-items-center justify-content-center gap-2' onClick={companyHandleClick} disabled={loader}>
                    {loader && <ButtonLoader />}
                    Continue
                  </button>
                </div>
              </form>
            </div>
          )}

          {currentStep === 4 && (
            <>
              {!activeOption && (
                <div className='upload-options d-flex flex-column gap-3 mt-4'>
                  <div className='option-box option-upload d-flex align-items-center' onClick={() => setActiveOption('docs')}>
                    <div className='icon-box me-3'>
                      <img src={UPLOAD_BLUE_ICON} alt='upload-icon' />
                    </div>
                    <div className='text-start'>
                      <h6 className='mb-0 outfit-semibold'>Upload Documents</h6>
                      <p className='mb-0 outfit-regular'>Add PDFs, Word docs, or other files</p>
                    </div>
                  </div>

                  <div className='option-box option-text d-flex align-items-center' onClick={() => setActiveOption('text')}>
                    <div className='icon-box me-3'>
                      <img src={TEXT_PURPLE_ICON} alt='upload-icon' />
                    </div>
                    <div className='text-start'>
                      <h6 className='mb-0 outfit-semibold'>Add Text</h6>
                      <p className='mb-0 outfit-regular'>Enter custom information directly</p>
                    </div>
                  </div>
                </div>
              )}
              <div className='mt-4'>
                {activeOption === 'docs' && (
                  <div className='d-flex flex-column align-items-start'>
                    <label className='btn-upload mb-3 outfit-medium'>
                      <FiUpload /> Select Files
                      <input type='file' accept='application/pdf' multiple onChange={handleSelectFile} style={{ display: 'none' }} />
                    </label>

                    {[...uploadedPdf, ...uploadedFiles].map((file, index) => (
                      <FileItem key={index} file={file} isUploaded={!uploadedFiles.includes(file)} progress={progress} onDelete={() => handleUploadedDelete(file.id)} />
                    ))}

                    <button className='btn-back-option outfit-medium' onClick={handleBackToOptions}>
                      Back to options
                    </button>
                  </div>
                )}

                {activeOption === 'text' && (
                  <>
                    <div className='d-flex flex-column mb-3'>
                      <textarea className='addtextbox-textarea' rows='4' placeholder='Enter text content' value={addText} onChange={(e) => setAddText(e.target.value)} />
                      <button className='btn-upload mt-2 outfit-medium' onClick={() => handleAddText()}>
                        <CgFileDocument />
                        Add Text
                      </button>
                    </div>
                    <button className='btn-back-option outfit-medium' onClick={handleBackToOptions}>
                      Back to options
                    </button>
                  </>
                )}
              </div>
              <button className='onboarding-btn d-flex align-items-center justify-content-center gap-3 outfit-medium' onClick={handleNext}>
                <img src={MULTISTAR_ICON} alt='star-icon' className='animation-icon' /> Continue
              </button>
            </>
          )}

          {currentStep === 5 && (
            <>
              <div className='onboarding-popup__leap-card text-center text-white p-4 rounded-4'>
                <div className='onboarding-popup__badge-wrapper d-flex justify-content-center mb-2'>
                  <div className='onboarding-popup__badge d-flex align-items-center justify-content-center position-relative'>
                    <img src={LEAP_ICON} alt='LEAP-icon' /> <span className='leap-badge outfit-regular position-absolute'>NEW</span>
                  </div>
                </div>
                <h5 className='onboarding-popup__title outfit-bold'>
                  Introducing <span className='onboarding-popup__title-highlight outfit-regular'>L.E.A.P.</span>
                </h5>
                <p className='onboarding-popup__subtitle outfit-regular'>Lead Engagement Automation Platform</p>

                <div className='onboarding-popup__feature-group d-flex flex-column flex-md-row justify-content-center gap-3 mt-4'>
                  <div className='onboarding-popup__feature-box'>
                    <h6 className='outfit-medium mb-0'>Lead Qualification</h6>
                    <p className='outfit-regular mb-0'>Auto-score lead quality</p>
                  </div>
                  {/* <div className='onboarding-popup__feature-box'>
                    <h6 className='outfit-medium mb-0'>Timed Sequences</h6>
                    <p className='outfit-regular mb-0'>Schedule perfect timing</p>
                  </div> */}
                </div>
              </div>
              <button
                className='onboarding-popup__leap-card-btn outfit-medium d-flex align-items-center justify-content-center gap-2'
                onClick={() => (!company ? setCurrentStep(7) : handleNext())}
              >
                Continue <MdArrowForward />
              </button>
            </>
          )}

          {currentStep === 6 && (
            <div className='publish-chatbot-popup text-center'>
              <button
                className='onboarding-btn outfit-medium d-flex align-items-center justify-content-center gap-2 mt-3'
                disabled={isPublishing}
                onClick={() => publishChatbotData(apiTokenData)}
              >
                {isPublishing && <ButtonLoader />} Publish
              </button>
            </div>
          )}

          {currentStep === 7 && (
            <div>
              <div className='status-card-wrapper'>
                <div className='status-card__header d-flex align-items-center'>
                  <div className='status-card__icon me-3'>
                    <MdOutlineThumbUpOffAlt />
                  </div>
                  <div>
                    <h6 className='mb-0 outfit-bold'>You're All Set!</h6>
                    <p className='outfit-regular mb-0'>Your AI chatbot is ready to engage with visitors</p>
                  </div>
                </div>

                <div className='row g-2 mt-4'>
                  <div className='col-6'>
                    <div className='status-feature status-feature--yellow'>
                      <div className='status-feature-icon'>
                        <RxLightningBolt />
                      </div>
                      <p className='outfit-regular'>AI Chat Ready</p>
                    </div>
                  </div>
                  <div className='col-6'>
                    <div className='status-feature status-feature--blue'>
                      <div className='status-feature-icon'>
                        <MdOutlineChatBubbleOutline />
                      </div>
                      <p className='outfit-regular'>Lead Capture</p>
                    </div>
                  </div>
                  <div className='col-6'>
                    <div className='status-feature status-feature--purple'>
                      <div className='status-feature-icon'>
                        <SiGoogleanalytics />
                      </div>
                      <p className='outfit-regular'>Analytics</p>
                    </div>
                  </div>
                  <div className='col-6'>
                    <div className='status-feature status-feature--green'>
                      <div className='status-feature-icon'>
                        <FaCheck />
                      </div>
                      <p className='outfit-regular'>
                        Smart Follow-ups <span className='outfit-medium'>(Coming Soon)</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <button className='onboarding-btn outfit-medium d-flex align-items-center justify-content-center gap-2' onClick={handleNext}>
                Get Started with ComniqAI <HiOutlineCheckBadge style={{ width: '20px', height: '20px' }} />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OnboardingPopup;
